export const QUERY_KEYS = {
  GOALS: 'goals',
  GOALSLOGS: 'goals_logs',
  MEMBER: 'member',
  ONBOARDING: 'onboarding',
  APPOINTMENTS: 'appointments',
  APPOINTMENT_NOTES: 'appointment_notes',
  APPOINTMENT_NOTE_ADDENDA: 'appointment_note_addenda',
  LAB_APPOINTMENTS: 'lab_appointments',
}
